<div class="app-select-wrapper" [ngClass]="customClass">
  <!-- Header Label -->
  <app-label
    *ngIf="resolvedLabel"
    [text]="resolvedLabel"
    [mandatory]="isRequired"
    [optional]="optional"
    [tooltip]="tooltip"
    [icon]="labelIcon"
    [size]="labelSize"
  ></app-label>

  <!-- Trigger Box -->
  <div
    class="app-select-trigger"
    [ngClass]="[
      'app-select-trigger--' + (size || 'md'),
      isOpen ? 'app-select-trigger--open' : '',
      hasError ? 'app-select-trigger--error' : '',
      disabled ? 'app-select-trigger--disabled' : '',
      containerClass
    ]"
    [style.height]="resolvedHeight ? resolvedHeight : null"
    [style.minHeight]="resolvedHeight ? resolvedHeight : null"
    (click)="toggleDropdown($event)"
  >
    <!-- Prefix Icon -->
    <span *ngIf="prefixIcon" class="app-select__prefix-icon">
      <img [src]="prefixIcon" alt="" />
    </span>

    <!-- Value Display -->
    <div class="app-select__value-display">
      <span *ngIf="selectedOption" class="app-select__selected-text">
        <img *ngIf="selectedOption.icon" [src]="selectedOption.icon" class="app-select__option-icon" alt="" />
        {{ selectedLabel }}
      </span>
      <span *ngIf="!selectedOption" class="app-select__placeholder">
        {{ placeholder }}
      </span>
    </div>

    <!-- Actions (Clear + Chevron) -->
    <div class="app-select__actions">
      <button
        type="button"
        *ngIf="clearable && selectedOption && !disabled"
        class="app-select__clear-btn"
        (click)="handleClear($event)"
        tabindex="-1"
      >
        <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor">
          <path
            d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm2.47-9.53a.75.75 0 0 0-1.06-1.06L8 5.82 6.59 4.41a.75.75 0 0 0-1.06 1.06L6.94 6.88 5.53 8.29a.75.75 0 1 0 1.06 1.06L8 7.94l1.41 1.41a.75.75 0 0 0 1.06-1.06L9.06 6.88l1.41-1.41z"
          />
        </svg>
      </button>

      <span class="app-select__chevron" [ngClass]="{ 'app-select__chevron--open': isOpen }">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M7 10l5 5 5-5z"/>
        </svg>
      </span>
    </div>
  </div>

  <!-- Popover Dropdown Menu -->
  <div
    *ngIf="isOpen"
    class="app-select__dropdown"
    [ngClass]="{ 'app-select__dropdown--top': actualPlacement === 'top' }"
    [style.minWidth]="dropdownMinWidth || null"
    (click)="$event.stopPropagation()"
  >
    <!-- Search Input -->
    <div *ngIf="searchable" class="app-select__search-box">
      <div class="app-select__search-wrap">
        <svg width="14" height="14" viewBox="0 0 16 16" fill="#9AA9BE" class="app-select__search-icon">
          <path
            d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"
          />
        </svg>
        <input
          type="text"
          class="app-select__search-input"
          [placeholder]="searchPlaceholder"
          [value]="searchTerm"
          (input)="onSearchInput($event)"
          (click)="$event.stopPropagation()"
          autofocus
        />
        <span
          *ngIf="searchTerm"
          class="app-select__search-clear"
          (click)="handleClearSearch($event)"
        >
          <svg width="12" height="12" viewBox="0 0 16 16" fill="currentColor">
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm2.47-9.53a.75.75 0 0 0-1.06-1.06L8 5.82 6.59 4.41a.75.75 0 0 0-1.06 1.06L6.94 6.88 5.53 8.29a.75.75 0 1 0 1.06 1.06L8 7.94l1.41 1.41a.75.75 0 0 0 1.06-1.06L9.06 6.88l1.41-1.41z"/>
          </svg>
        </span>
      </div>
    </div>

    <!-- Options List -->
    <div class="app-select__options-list">
      <div
        *ngFor="let opt of filteredOptions; trackBy: trackByOption"
        class="app-select__option"
        [ngClass]="{
          'app-select__option--selected': isOptionSelected(opt),
          'app-select__option--disabled': opt.disabled
        }"
        (click)="selectOption(opt, $event)"
      >
        <img *ngIf="opt.icon" [src]="opt.icon" class="app-select__option-icon" alt="" />
        <div class="app-select__option-content">
          <span class="app-select__option-label">{{ opt.label }}</span>
          <span *ngIf="opt.sublabel" class="app-select__option-sublabel">{{ opt.sublabel }}</span>
        </div>
      </div>

      <div *ngIf="filteredOptions.length === 0" class="app-select__no-options">
        {{ emptyText }}
      </div>
    </div>

    <!-- Optional Sticky Footer Button -->
    <div *ngIf="footerBtnName" class="app-select__footer">
      <app-add-action-button
        class="w-100"
        [fullWidth]="true"
        [btnName]="footerBtnName"
        [isSvgShow]="footerBtnIcon"
        (btnClick)="onFooterBtnClick($event)"
      ></app-add-action-button>
    </div>
  </div>

  <!-- Error Message -->
  <div *ngIf="hasError" class="app-select__error">
    {{ errorMsg }}
  </div>

  <!-- Helper Text -->
  <div *ngIf="helperText && !hasError" class="app-select__helper">
    {{ helperText }}
  </div>
</div>
